import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LegalPagesService } from '../../services/legal-pages.service';

@Component({
  selector: 'app-data-protection',
  standalone: false,
  templateUrl: './data-protection.component.html',
  styleUrl: './data-protection.component.scss',
})
export class DataProtectionComponent implements OnInit, OnDestroy {
  private legalPagesService = inject(LegalPagesService);

  dataProtectionHtml = '';

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.legalPagesService
      .getLegalHtmlPage('data-protection')
      .pipe(takeUntil(this.destroy$))
      .subscribe((text) => (this.dataProtectionHtml = text));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
